var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElectrifyDisc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "group-6-a",
    x1: "1.561%",
    x2: "100%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0259AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "53.006%",
    stopColor: "#0495FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#19D5FF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "url(#group-6-a)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M39.8405016,59.5789474 C35.9756677,59.5789474 32.8421053,56.1895046 32.8421053,52.0123515 C32.8421053,46.0865466 39.8405016,39.5789474 39.8405016,39.5789474 C39.8405016,39.5789474 46.8421053,46.0865466 46.8421053,52.0123515 C46.8421053,56.1895046 43.7053355,59.5789474 39.8405016,59.5789474 M39.8421053,15.5789474 C39.8421053,15.5789474 21.8421053,31.1975834 21.8421053,45.4225665 C21.8421053,55.4471445 29.9006558,63.5789474 39.8421053,63.5789474 C49.7835547,63.5789474 57.8421053,55.4471445 57.8421053,45.4225665 C57.8421053,31.1975834 39.8421053,15.5789474 39.8421053,15.5789474"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectrifyDisc);
export default __webpack_public_path__ + "static/media/electrify-disc.642d13b16f10ea7d6de7c744399fb23d.svg";
export { ForwardRef as ReactComponent };